import { render, staticRenderFns } from "./ChallengerPage.vue?vue&type=template&id=2eee2afd&scoped=true"
import script from "./ChallengerPage.vue?vue&type=script&lang=ts"
export * from "./ChallengerPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee2afd",
  null
  
)

export default component.exports